<template>
	<div>
<!--		<breadcrumb :routerList="[{to:'/jingpin/list',title:'竞品管理'},{title:'竞品列表'}]"/>-->
    <Breadtabsheader/>
		<div class="" style="margin: 20px">
			<div class="h-piece">
				<div class="h-pieceIn2">
					<div class="h-pieceCon2">
						<div class="h-formBox">
							<el-form :inline="true" class="demo-form-inline h-formBorder">
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="客户名称">
										<el-select v-model="cusmname" placeholder="请选择" filterable >
											<el-option v-for="item in cusmnameOptions" :key="item.value"
													:label="item.label" :value="item.value">
											</el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="产品型号">
										<el-select v-model="bigtype" placeholder="请选择" filterable >
											<el-option v-for="item in bigtypeOptions" :key="item.value"
												:label="item.label" :value="item.value">
											</el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="　　出厂截至日期" >
										<el-date-picker type="date" :clearable="false" value-format="yyyy-MM-dd" v-model="timechange" placeholder="选择时间"  style="width: 100%;"></el-date-picker>
									</el-form-item>
									<el-form-item class="right-btn">
										<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
										<el-button class="h-btn h-formBtn h-bgwhite" @click="qingkong">重置</el-button>
									</el-form-item>
								</div>
								
							</el-form>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="h-table" style="margin:0 20px">
			<el-table
					ref="multipleTable"
					@selection-change="handleSelectionChange"
					:data="tableData2"
					stripe
					style="width: 100%"
					:border="true"
					max-height="450"
					>
				<el-table-column
					type="selection"
					width="45"
					>
				</el-table-column>
				<el-table-column
					fixed
					type="index"
					label="#"
					width="40">
				</el-table-column>
				<el-table-column
					prop="userName"
					 :show-overflow-tooltip="true"
					label="客户名称"
					>
					<template slot-scope="scope">
						<div style="text-align: left;">
							{{scope.row.userName}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="channel"
					label="销售渠道"
					width="150">
					<template slot-scope="scope">
						<dictname category="sales_region"  :v="scope.row.channel"/>
					</template>
				</el-table-column>
				<el-table-column
					prop="area"
					label="销售区域"
					width="150">
					<template slot-scope="scope">
						<dictname category="YLRegion"  :v="scope.row.area"/>
					</template>
				</el-table-column>
				<el-table-column
					prop="specification"
					label="产品型号"
					:show-overflow-tooltip="true"
					width="250">
						<template slot-scope="scope">
							<div style="text-align: left;">
								{{scope.row.specification}}
							</div>
						</template>
				</el-table-column>
				<el-table-column
					prop="barCode"
					label="条形码"
					:show-overflow-tooltip="true"
					width="250">
					<template slot-scope="scope">
						<div style="text-align: left;">
							{{scope.row.barCode}}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="exfactoryDate"
					sortable
					label="生产日期"
					 :show-overflow-tooltip="true"
					width="150">
				</el-table-column>
			</el-table>
			<div class="h-tableB h-mrt30">
				<div class="h-tableBL">
					<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="outexcel">批量导出</el-button>
				</div>
				<div class="h-pagination2">
					<pagination :page="q" @query="query" />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import ss from '../../../api/SystemService'
	require('echarts/map/js/china.js')
    export default {
        data() {
            return {

				//检索标志
				shifoujiansuo:false,


				//翻页入参
				q: {

					pageSize: 10,
					pageNo: 1,
					total:0,

				},


				//选择时间
				timechange:'',


				//产品集合对象
				chanpin:[


				],

				//产品信息id:唯一用户信息对象
				yonghu:{

				},

				//产品信息id:大类对象
				dalei:{

				},


				//客户名选中值
				cusmname: '',

				cusmnameOptions: [],

				//大类选中值
                bigtype: '',

				bigtypeOptions: [],

				//等级选中值
				leltype: '关注等级',

				lelOptions: [{
					value: '1',
					label: '高'
				}, {
					value: '2',
					label: '中'
				}, {
					value: '3',
					label: '低'
				}, {
					value: '0',
					label: '取消关注'
				}],

				idmsg:'',

				comp:{

				},

			   //表格
				 multipleSelection: [],
				 tableData2: [],
				 tableData3: [],
            }
        },
		created() {
			this.query();
		},
        methods: {
			//查询翻页
			query() {
				this.q.userName=this.cusmname,
				this.q.specification=this.bigtype,
				this.q.exfactoryDate=this.timechange,
				ss.CompetitorsManager.selectPage(this.q).then(rd => {
					this.q.total = rd.total;
					this.gettableels(rd.records);
				})
			},
			handleFilter() {
				this.shifoujiansuo=true;
				this.q.pageNo = 1;
				this.query();
			},
			//导表
			outexcel() {
				var canshu2 = {
					userName:this.cusmname,
                    specification:this.bigtype,
					exfactoryDate:this.timechange,
				};
				ss.CompetitorsManager.downloadExcel(canshu2);
			},
			gettableels(vw){
				this.tableData2 = [];
				this.tableData3 = [];
				if(!this.shifoujiansuo) {
					this.cusmnameOptions = [];
					this.bigtypeOptions = [];
				}
				for(var ui in vw) {
					var dd = 0;
					var rr = 0;
					if(!this.shifoujiansuo) {
// 						if (ui == 0) {
// 
// 							var cusmnameonee = {
// 								value: '',
// 								label: '--请选择--',
// 							}
// 
// 							this.cusmnameOptions.push(cusmnameonee);
// 							this.bigtypeOptions.push(cusmnameonee);
// 							console.log("this===",this.bigtypeOptions)
// 
// 						}
						var cusmnameone = {
							value: vw[ui].userName,
							label: vw[ui].userName,
						}
						for (var tt in this.cusmnameOptions) {
							if (this.cusmnameOptions[tt].value == cusmnameone.value||cusmnameone.value==null||cusmnameone.value=='') {
								dd = 1;
							}
						}
						if(cusmnameone.value !=undefined){
							if (dd == 0) {
								console.log(cusmnameone,'看看啥???')
								this.cusmnameOptions.push(cusmnameone);
							}
						}
						var bigtypeone = {
							value: vw[ui].specification,
							label: vw[ui].specification,
						}
						for (var hh in this.bigtypeOptions) {
							if (this.bigtypeOptions[hh].value == bigtypeone.value) {
								rr = 1;
							}
						}
						if (rr == 0) {
							this.bigtypeOptions.push(bigtypeone);
						}
					}
					var table =  {
						//序号
						index:ui,
						//产品信息id
						pid: vw[ui].pid,
						//客户名
						userName: vw[ui].userName,
						//渠道
						channel:vw[ui].channel,
						//区域
						area: vw[ui].area,
						//型号
						specification: vw[ui].specification,
						//条形码
						barCode: vw[ui].barCode,
						//生产日期
						exfactoryDate: vw[ui].exfactoryDate,
						//产品大类
						category: vw[ui].category,
					};
					this.tableData2.push(table);
					this.tableData3.push(table);
				}
			},
			//清空选项
			qingkong(){
				this.cusmname='';
				this.bigtype='';
				this.timechange='';
				this.shifoujiansuo=false;
				this.query();
			},
			//表格
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
        },
		mounted(){
			
		},
    }
</script>